const Layout = () => import('@/layout/index.vue')

export default {
    path: '/personal',
    component: Layout,
    redirect: '/personal/index',
    name: 'personal',
    meta: {
        title: '个人中心',
        icon: 'personal'
    },
    children: [
        {
            path: 'index',
            name: 'PersonalIndex',
            component: () => import('@/views/personal/index.vue'),
            meta: {
                title: '个人中心',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/personal',
                auth: ['personal']
            }
        }
    ]
}
